const postServices = {
  toastr: 'Serviço adicionado',
  toastrError: 'Serviço já cadastrado',
  toastrError1: 'Nome já cadastrado'
};

export default postServices;
